// extracted by mini-css-extract-plugin
export var attachmentContainer = "_na-0";
export var fileList = "_na-2";
export var removeFileButton = "_na-1";